import {BASE_WIDTH, BASE_HEIGHT} from '../config';

// 通过div形式 生成文字图片
export const generatorImageByDiv = elementInfo => {
    try {
        if (!elementInfo.name) {
            return {};
        }

        const dom = document.createElement('div');
        const childDom = document.createElement('div');
        childDom.innerText = elementInfo.name;

        Object.keys(elementInfo.styles).forEach(key => {
            childDom.style[key] = elementInfo.styles[key];
        });

        dom.style.width = `${(elementInfo.w * BASE_WIDTH).toFixed(3)}px`;
        dom.style.height = `${(elementInfo.h * BASE_HEIGHT).toFixed(3)}px`;
        dom.style.display = 'flex';
        dom.style.background = 'transparent';
        dom.style['align-items'] = 'center';
        dom.style['justify-content'] = 'center';

        if (elementInfo.styles.textAlign) {
            const posMap = {
                center: 'center',
                left: 'start',
                right: 'end'
            };

            dom.style['justify-content'] = posMap[elementInfo.styles.textAlign];
        }

        dom.style.position = 'absolute';
        dom.style.left = '9999px';
        dom.style.top = '9999px';

        childDom.setAttribute('class', 'generate-txt-canvas');
        childDom.setAttribute('data-text', elementInfo.name);

        dom.appendChild(childDom);
        document.body.appendChild(dom);

        // 获取外部dom的宽度和高度
        let domWidth = dom.offsetWidth;
        let domHeight = dom.offsetHeight;

        // 获取内部dom的宽度和高度
        let childDomWidth = childDom.offsetWidth;
        let childDomHeight = childDom.offsetHeight;

        // 获取内部dom边框距离外部dom边框的距离
        let domRect = dom.getBoundingClientRect();
        let childDomRect = childDom.getBoundingClientRect();

        // 计算距离
        let distanceToTop = childDomRect.top - domRect.top;
        let distanceToLeft = childDomRect.left - domRect.left;
        let distanceToRight = domRect.right - childDomRect.right;
        let distanceToBottom = domRect.bottom - childDomRect.bottom;

        document.body.removeChild(dom);
        return {
            domWidth,
            domHeight,
            childDomWidth,
            childDomHeight,
            distanceToTop,
            distanceToLeft
        };
    }
    catch (e) {
        console.log(e);
        return {};
    }
};
